import { environment } from '@/helpers/Environment';
import { flags } from '@/store/Flags';
// TODO Enable for more countries.
export const supportedCountries = new Set(['USA', 'GBR', 'CAN', 'AUS', 'NZL']);
export const addressFieldNames = ['address', 'city', 'state', 'county', 'zip_code', 'country'];
export function getAddressAutocompleteApiKey() {
    return environment.config.loqate_api_key;
}
export function alterAddressFieldsForAutocomplete(fields) {
    const result = fields;
    // Extract `address` separately as it should always come immediately after `country`.
    // The other address fields should be in their original order.
    const addressField = extractFields(result, ['address']);
    const otherAddressFields = extractFields(result, ['zip_code', 'city', 'state', 'county']);
    // Find the position of the country field.
    // This must be done after the splice above as that can change the position of the country field.
    const country = result.findIndex((field) => field.key === 'country');
    // Position the address fields immediately after the country field.
    result.splice(country + 1, 0, ...addressField, ...otherAddressFields);
    return result;
}
function extractFields(fields, extract, result = []) {
    const index = fields.findIndex((field) => extract.includes(field.key));
    if (index !== -1) {
        const formInputField = fields.splice(index, 1)[0];
        // ❗️Recursion!
        return extractFields(fields, extract, result.concat(formInputField));
    }
    else {
        return result;
    }
}
export function addressSearch(country, search) {
    return loqateRequest('https://api.addressy.com/Capture/Interactive/Find/v1.10/json3.ws', {
        Countries: country,
        ...search,
    });
}
export function retrieveAddress(id) {
    return loqateRequest('https://api.addressy.com/Capture/Interactive/Retrieve/v1.20/json3.ws', { Id: id });
}
function loqateRequest(url, params) {
    const key = getAddressAutocompleteApiKey();
    if (!key) {
        return Promise.reject('No Loqate API Key');
    }
    const urlWithParams = addParamsToUrl(url, {
        Key: key,
        ...params,
    });
    return fetch(urlWithParams, {
        method: 'GET',
        headers: {
            'Content-type': 'application/x-www-form-urlencoded',
        },
    }).then((r) => handleLoqateResponse(r));
}
function addParamsToUrl(url, params) {
    if (Object.values(params).length === 0) {
        return url;
    }
    const urlParams = Object.entries(params);
    return `${url}?${new URLSearchParams(urlParams)}`;
}
function handleLoqateResponse(response) {
    if (response.ok && response.status === 200) {
        return response.json().then((data) => {
            if (data.Items.length == 1 && typeof data.Items[0].Error != 'undefined') {
                throw data.Items[0];
            }
            else {
                return data.Items;
            }
        });
    }
    else {
        throw response;
    }
}
function addressLine(address) {
    return [address.Line1, address.Line2, address.Line3, address.Line4, address.Line5].filter((a) => a !== '').join(', ');
}
function getCountyData(address) {
    // UK addresses use Province for county. Fallback to City for London addresses where Province is empty.
    if (flags.address_autocomplete_for_uk_counties && address.CountryIso2 === 'GB') {
        return address.Province || address.City;
    }
    else {
        // Other countries use Province for different sub-national divisions, such as state, so we can't enable this generally for all countries.
        return undefined;
    }
}
export function getAddressData(address) {
    return {
        address: addressLine(address),
        city: address.City,
        state: address.ProvinceCode && address.Province,
        county: getCountyData(address),
        zipCode: address.PostalCode,
    };
}
export function isLoqateError(error) {
    return !(error.Description == undefined);
}
